module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-btn', {
    attrs: {
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "pink",
      "dark": "",
      "fixed": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = !_vm.dialog
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "800px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-4 py-4 title"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('v-container', {
    staticClass: "pa-4",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_vm._t("itemInputField", null, {
    "model": _vm.model
  })], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Amount"
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = $$v
      },
      expression: "amount"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Is available"
    },
    model: {
      value: (_vm.isAvailable),
      callback: function($$v) {
        _vm.isAvailable = $$v
      },
      expression: "isAvailable"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Is external vendor"
    },
    model: {
      value: (_vm.isVendor),
      callback: function($$v) {
        _vm.isVendor = $$v
      },
      expression: "isVendor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Edit checklist for the item after saving"
    },
    model: {
      value: (_vm.editCheckListAfterSave),
      callback: function($$v) {
        _vm.editCheckListAfterSave = $$v
      },
      expression: "editCheckListAfterSave"
    }
  })], 1), _vm._v(" "), (_vm.savedItemId > 0) ? _c('ItemCheckList', {
    attrs: {
      "item-id": _vm.savedItemId,
      "item-type": _vm.itemTypeID
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', [(_vm.savedItemId === 0) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.saveNew
    }
  }, [_vm._v("Save")]) : _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": ""
    }
  }, [_vm._v("Saved")]), _vm._v(" "), (_vm.savedItemId === 0) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")]) : _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Close dialog")])], 1)], 1)], 1), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9942b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppAddItemButtonBase.vue
// module id = 1007
// module chunks = 1